var _path, _path2, _rect, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFanonthree = function SvgFanonthree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929ZM16 3.46641C15.5226 2.63938 14.4044 2 12.5 2C8.94 2 8.15 5.96 10.14 9.65C9.73 9.97 9.41 10.39 9.22 10.87C8.29 10.68 7.24 10.25 6.74 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.96 15.85 9.65 13.87C9.97 14.27 10.4 14.59 10.89 14.79C10.69 15.71 10.25 16.75 9.27 17.24C6.91 18.42 7 22 11.5 22C15.08 22 15.87 18.03 13.88 14.34C14.28 14 14.59 13.59 14.79 13.11C15.1875 13.1912 15.6088 13.3181 16 13.5141V9.42451C15.4531 9.59836 14.8985 9.83353 14.35 10.13C14.03 9.73 13.61 9.42 13.13 9.22C13.32 8.29 13.76 7.24 14.75 6.75C15.3195 6.46526 15.7451 6.04135 16 5.56201V3.46641Z",
    fill: "#52C41A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16H22V21C22 21.5523 21.5523 22 21 22H19C18.4477 22 18 21.5523 18 21V16Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 4,
    height: 4,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18 2.44772 18.4477 2 19 2H21C21.5523 2 22 2.44772 22 3V8H18V3Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFanonthree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fanonthree.cc84da18.svg";
export { ForwardRef as ReactComponent };